import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { AuthorizationGuard } from '@shared/authentication/authentication.guard';
import { BOOKING_VIEW_PAGE } from '@shared/constants/routing-constants';

const routes: Routes = [
  {
    path: BOOKING_VIEW_PAGE,
    canActivate: [AuthorizationGuard],
    loadComponent: () =>
      import('./Pages/kfm-booking-view.component').then(
        (m) => m.KfmBookingViewComponent,
      ),
  },
];

export const bookingViewRoutingModule: ModuleWithProviders<RouterModule> =
  RouterModule.forChild(routes);
